import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ISort } from '@app/modules/table/children/table-column-action/interfaces/table-column-action.interface';
import { FileFactor } from '@components/fields/file/models/fileFactor';
import { SignData } from '@components/fields/file/models/signData';
import { AppService } from '../../app.service';
import { AppHelper } from '../../core/app.helper';
import { InterfaceSettingsTable } from '../../modules/table/table.interface';

@Component({
    selector: 'app-crypto-pro-certificate-table',
    templateUrl: './crypto-pro-certificate-table.component.html',
    styleUrls: ['./crypto-pro-certificate-table.component.css'],
})
export class CryptoProCertificateTableComponent implements AfterViewInit {
    /**
     * Элемент таблицы
     * @type {MatTableDataSource<>}
     */
    dataTables = new MatTableDataSource();
    /**
     * Элемент сортировки
     */
    @ViewChild('UsersMatSort', { static: true }) sortTables;
    /**
     * Настройки таблицы
     */
    settingsTable: InterfaceSettingsTable = {
        displayedColumns: [
            'created_at',
            'created_by',
            'owner',
            'roles',
            'publisher',
            'valid_to',
            'type',
            'status',
            'sign',
        ],
        userSort: [{ name: 'date', sort: 'asc' }],
    };
    /**
     * Флаг пустого результата поиска
     */
    emptyResult: boolean = false;
    /**
     * Инициализация таблицы
     */
    initTable: boolean = false;

    /**
     * Конструктор
     * @param appService сервис взаимодействия с внешними ресурсами
     * @param dialogRef ссылка на диалог
     * @param data данные для диалога
     */
    constructor(
        public appService: AppService,
        public dialogRef: MatDialogRef<CryptoProCertificateTableComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            data: {
                file: any;
                signs: SignData[];
                upload: boolean;
                title: string;
            };
        },
    ) {}

    /**
     * Событие после завершения инициализации вьюшки
     */
    ngAfterViewInit(): void {
        this.dataTables.sort = this.sortTables;
        if (!this.data.data?.upload) {
            this.settingsTable.displayedColumns = this.settingsTable.displayedColumns.filter((item) => item !== 'sign');
        }
        setTimeout(() => {
            this.getData();
        });
    }

    /**
     * Получение данных по пользователям
     */
    getData(): void {
        this.dataTables.filteredData = [];
        if (this.data.data.signs && this.data.data.signs.length) {
            this.data.data.signs.map((value) => {
                const record = Object.assign({}, value);
                this.dataTables.filteredData.push(record);
            });
        }
        this.emptyResult = this.dataTables.filteredData.length <= 0;
        this.initTable = true;
    }

    /**
     * Обработка события сортировки
     * @param {ISort} event событие сортировки
     */
    sortData(event: ISort[]): void {
        this.settingsTable.userSort = [];
        event.map((active) => {
            this.settingsTable.userSort.push({
                name: active.fieldName,
                sort: active.direction,
            });
        });
        this.getData();
    }

    /**
     * закрытие диалога
     */
    close() {
        this.dialogRef.close({ save: false });
    }

    /**
     * Скачивание подписи
     * @param sign содержимое файла
     * @param index номер
     */
    downloadSign(sign: string, index: number) {
        let names = [];
        if (this.data.data.file instanceof FileFactor) {
            names.push(this.data.data.file.fileName);
        } else {
            names = this.data.data.file.name.split('.');
        }

        let name = 'Sign';
        if (names && names[0]) {
            name = names[0];
        }
        for (let i = 0; i <= index; i++) {
            name += '.sig';
        }
        AppHelper.createAndDownloadBlobFile(sign, { type: 'text/plain' }, name);
    }
}
